module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg26.bdda7312.jpg";